import React, { useState, useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux'

import Aux from '../../hoc/Aux';
import { useForm } from 'react-hook-form'
import * as actions from '../../store/actions/index';
import Navigation from './Navigation';
import { useTranslation } from 'react-i18next';
import useCustomHtmlTranslation from '../../hooks/useCustomHtmlTranslation';
import useCustomTranslation from '../../hooks/useCustomTranslation';
import { format } from 'date-fns'
import { useAlert } from 'react-alert';
import { set } from 'date-fns';

const accessToken = (props) => {

  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { register, setError, errors, handleSubmit } = useForm();
  const ht = useCustomHtmlTranslation();
  const ct = useCustomTranslation();
  const [tokens, setTokens] = useState([]);
  const alert = useAlert();

  const onDeleteSubmit = id => {
    return dispatch( actions.deleteAccessToken(id) ).then( (res) => {
      dispatch( actions.fetchAccessTokens() ).then( (res) => {
        setTokens(res);
      });
      alert.show( ct('alert.delete_access_token.success'), {type: "success"});
    });
  } ;

  const onSaveSubmit = data => {
    dispatch( actions.saveAccessToken(data) ).then( (res) => {
      setTokens(res); 
      alert.show( ct('alert.create_access_token.success'), {type: "success"});
    });
  } ;

  useEffect(() => {
    dispatch( actions.fetchAccessTokens() ).then( (res) => {
      setTokens(res);
    }); 
  }, []);

  const fieldClassName = () => {
    return "form-control"
  }

  const copyToClipboard = text => {
    const tempInput = document.createElement('textarea');
    tempInput.style.position = 'absolute';
    tempInput.style.left = '-9999px';
    tempInput.value = text;
    document.body.appendChild(tempInput);
    tempInput.select();
    document.execCommand('copy');
    document.body.removeChild(tempInput);
};

  return (
    <Aux>
    	<div className="main-container">
    		<div className="container">
    			<div className="row justify-content-center mt-5">
    				<div className="col-lg-10 col-xl-9">
    					<div className="page-header">
    						<h1 className="pb-2">{ ct('delete_account.title') }</h1>
                <span className="lead">
                  { ht('account.access_token.site_description') }
                </span>
    					</div>
    				</div>
    			</div>
    			<div className="row justify-content-center mt-3">
    				<div className="col-lg-3 mb-3">
              <Navigation activeItem="manage_access_token" />
    				</div>
    				<div className="col-lg-7 col-xl-6">
    					<div className="card">
    						<div className="card-body">
    							<div className="tab-content">
    								<div className="tab-pane fade show active" role="tabpanel" id="userdata">
    									<h4>{ ct('manage_access_token.subtitle') }</h4>
    									<form onSubmit={handleSubmit(onSaveSubmit)}>
                        <div className="form-group row align-items-center">
                          <label className="col-3">{ ct('create_access_token.form.token_name') }</label>
                          <div className="col">
                            <input
                              type="text"
                              className={fieldClassName()}
                              name="name"
                              defaultValue=""
                              ref={register({ required: false})} />
                          </div>
                          
                        </div>
    										<div className="row justify-content-end">
    											<button type="submit" className="btn btn-primary btn-project">{ ct('create_access_token.form.button.submit') }</button>
    										</div>
    									</form>
    								</div>

                    <br />


                    <table className="table table-striped downloads">
                      <thead>
                        <tr>
                          <th scope="col">{ t('access_tokens.box_management.table_col.created_at')}</th>
                          <th scope="col">{ t('access_tokens.box_management.table_col.active_tokens')}</th>
                          <th scope="col"></th>
                          <th scope="col"></th>
                        </tr>
                      </thead>
                      <tbody>
                        { tokens.map( doc =>
                          <tr className='updated_file' key={doc.id}>
                            <td>{ format(new Date(doc.created_at), 'dd.MM.yyyy')  }</td>
                            <td><small>{doc.notice}</small><br />{doc.tokenstring}</td>

                            

                            <td><button type="button" onClick={ () => { copyToClipboard(doc.tokenstring) } } className="btn btn-round"> <i className="material-icons">content_copy</i> </button></td>
                            <td style={{textAlign: "right", paddingRight: "20px"}}><button  onClick={ () => { onDeleteSubmit(doc.id) } } className="btn btn-primary btn-project">{ ct('delete_access_token.form.button.submit') }</button></td>
                          </tr>
                        )}
                      </tbody>
                    </table>


    							</div>
    						</div>
    					</div>
    				</div>






    			</div>
    		</div>
    	</div>
    </Aux>
  );


};

export default accessToken;



// WEBPACK FOOTER //
// ./src/components/User/AccessToken.js